import { Rule } from '../types';

const MM_TO_IN = 25.4;
const LANDING_MIN_IN = 1500 / MM_TO_IN; // ~59.06"

export const ruleLandings: Rule = (submission) => {
  const shape = submission.config.shape;

  if (shape.kind === 'straight') return null;
  if (shape.kind === 'freeform' || shape.kind === 'switchback') return null;

  // U180 specific: validate landingDepthIn
  if (shape.kind === 'U180' && shape.landingDepthIn < LANDING_MIN_IN) {
    return {
      ruleId: 'landing-size-min',
      severity: 'warn',
      humanMessage: `Le palier de transition (${shape.landingDepthIn}") est plus petit que le minimum recommandé (60" / 1500 mm).`,
      suggestion: {
        type: 'add-landing',
        patch: {
          config: { ...submission.config, shape: { ...shape, landingDepthIn: 60 } },
        },
      },
    };
  }

  // L90 or U180: signal informational that landing is required (computePlatforms auto-adds it)
  return {
    ruleId: 'landing-required-direction-change',
    severity: 'info',
    humanMessage: `Palier de transition automatique ajouté (changement de direction).`,
  };
};
